import { action } from 'mobx';
import { observer } from 'mobx-react';
import { fromArrayMaybe } from 'nonempty-list';
import * as React from 'react';
import { T, TPlainTextKey } from '../../../../Translations';
import { StringField, isRequired } from '../../Types';
import Label from '../Label';
import InputComponent from './InputComponent';

interface Props {
  field: StringField;
  footer?: TPlainTextKey;
  disabled: boolean;
}

const multiLineClassName = (field: StringField): string =>
  field.content.multiline ? 'string' : 'text';

const requiredClassName = (field: StringField): string =>
  isRequired(field) ? 'required' : 'optional';

const errorClassName = (field: StringField): string =>
  field.errors.length > 0 ? 'error has-error' : '';

const onChange = (field: StringField) => action((value: string) => (field.value = value));

const classNames = (field: StringField): string =>
  [multiLineClassName(field), requiredClassName(field), errorClassName(field)].join(' ');

const NonRichtextStringInput: React.FC<Props> = ({ field, footer, disabled }) => {
  return (
    <div className={`${classNames(field)}`}>
      <Label field={field} />
      <span>
        <InputComponent
          field={field}
          onChange={onChange(field)}
          isDisabled={disabled}
          kind={field.content.multiline ? 'MultiLine' : 'SingleLine'}
        />
        {footer ? (
          <p className="text-sm text-gray-500">
            <T kind={footer} />
          </p>
        ) : (
          <></>
        )}
        {fromArrayMaybe(field.errors)
          .map((e) => <span className="help-block">{e.join(', ')}</span>)
          .getOrElse(() => (
            <></>
          ))}
      </span>
    </div>
  );
};

export default observer(NonRichtextStringInput);
